import { z } from 'zod';
/** Codes de boutique connus à la bascule (`01` §0). La liste reste ouverte en base. */
export const STORE_CODES = ['fr', 'eu', 'de', 'uk', 'it', 'pro'];
/**
 * Le code boutique est libre en base (une boutique peut être ajoutée depuis
 * l'interface) : minuscules, chiffres et tirets.
 */
export const storeCodeSchema = z
    .string()
    .min(2)
    .max(20)
    .regex(/^[a-z0-9-]+$/, 'code boutique invalide (minuscules, chiffres et tirets)');
/** Mode d'une boutique — `03` §2 (`stores.mode`) et `01` §0. */
export const STORE_MODES = ['shadow', 'active', 'paused'];
export const storeModeSchema = z.enum(STORE_MODES);
export const STORE_MODE = {
    shadow: {
        code: 'shadow',
        label: 'Shadow',
        tone: 'blue',
        description: 'Les CSV sont générés mais jamais envoyés à Martelet.',
    },
    active: {
        code: 'active',
        label: 'Actif',
        tone: 'green',
        description: 'Les commandes sont préparées et envoyées à Martelet.',
    },
    paused: {
        code: 'paused',
        label: 'Pause',
        tone: 'gray',
        description: 'Aucun traitement ; les commandes s’accumulent en « planifiée ».',
    },
};
/** État de connexion Shopify d'une boutique — `03` §2 (`stores.connection.status`). */
export const CONNECTION_STATUSES = ['not_installed', 'installed', 'disconnected'];
export const connectionStatusSchema = z.enum(CONNECTION_STATUSES);
export const CONNECTION_STATUS = {
    not_installed: { code: 'not_installed', label: 'Non installée', tone: 'gray' },
    installed: { code: 'installed', label: 'Installée', tone: 'green' },
    disconnected: { code: 'disconnected', label: 'Déconnectée', tone: 'red' },
};
//# sourceMappingURL=store.js.map